module.exports = __webpack_public_path__ + "assets/img/left_2.b848370b.png";